import { useMemo } from 'react';
import { useWixFlowContext } from '../components/WixFlow/WixFlowContext';
export const useExperiments = () => {
  const {
    flowContext
  } = useWixFlowContext();
  return useMemo(() => (flowContext == null ? void 0 : flowContext.experiments) || {}, [flowContext == null ? void 0 : flowContext.experiments]);
};
//# sourceMappingURL=useExperiments.js.map